var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTablePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Resouce / Illust / Bag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 16H46V46H4V16Z",
    fill: "#E7EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14 11.5V16H17V13.7048H33V16H36V11.5C36 11.2239 35.7761 11 35.5 11H14.5C14.2239 11 14 11.2239 14 11.5Z",
    fill: "#CFD6D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.5 21H53.5L46 46H4L11.5 21Z",
    fill: "#F7F9FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTablePlaceholder);
export default __webpack_public_path__ + "static/media/icon-table-placeholder.28e1fc8d755dcb993589e361b56f9d21.svg";
export { ForwardRef as ReactComponent };